import React from 'react';
import ContentCard from '../ContentCard';

const Introduction = () => {
    return (
        <div className='left-align'>
            <ContentCard
                title="Introduction to our Privacy Notice"
                content={
                    <>
                        <p>Stack Privacy values your privacy. We handle your personal data with care,
                            ensuring we follow all relevant data protection laws. Here's our privacy notice to explain how we manage and protect your information.</p>
                        <p>Click on the relevant section in the menu to the left to read more.</p>
                        <p>You can contact us at: <a href="mailto:anton@stack-privacy.com">anton@stack-privacy.com</a> or the Contact Page.</p>
                    </>
                }
            />
        </div>
    );
};

export default Introduction;
